import React from 'react';
import { ShieldCheck, Video, ClipboardCheck, Award } from 'lucide-react';
import { VERIFICATION_BADGES } from '../data/mockData';

const ICONS = {
  business: ShieldCheck,
  video: Video,
  audit: ClipboardCheck,
  premium: Award,
};

export const VerificationBadge = ({ type, size = 'sm' }) => {
  const meta = VERIFICATION_BADGES[type];
  if (!meta) return null;
  const Icon = ICONS[type];

  const sizes = {
    sm: 'px-2 py-1 text-[10px] gap-1',
    md: 'px-3 py-2 text-xs gap-1.5',
  };

  return (
    <div
      data-testid={`verification-badge-${type}`}
      title={meta.description}
      className={`inline-flex items-center rounded-full border bg-transparent font-mono-data uppercase tracking-wider text-[--giwahs-gold-2] ${sizes[size]}`}
      style={{ borderColor: 'rgba(200, 169, 107, 0.55)', color: '#DCBE82' }}
    >
      <Icon size={size === 'sm' ? 11 : 13} strokeWidth={1.6} />
      <span className="font-semibold">{meta.code}</span>
    </div>
  );
};

export const VerificationBadgeFull = ({ type }) => {
  const meta = VERIFICATION_BADGES[type];
  if (!meta) return null;
  const Icon = ICONS[type];
  return (
    <div data-testid={`verification-badge-full-${type}`} className="flex items-start gap-3 border border-black p-4">
      <Icon size={18} strokeWidth={1.5} className="mt-0.5 shrink-0" />
      <div>
        <div className="label-overline">{meta.label}</div>
        <div className="mt-1 text-xs leading-relaxed text-neutral-600">{meta.description}</div>
      </div>
    </div>
  );
};

export default VerificationBadge;
